import styled from 'styled-components'

const SubHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
  gap: 8px;
  color: ${(props) => props.theme.token.colorText};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 0 8px;

    > * {
      width: 100%;
      justify-content: flex-start;
      margin: 0;
    }

    > div {
      display: flex;
      flex-wrap: nowrap;
      gap: 8px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
`

interface SubHeaderProps {
  children: React.ReactNode
  style?: React.CSSProperties
}

const SubHeader = ({ children, style }: SubHeaderProps) => {
  return <SubHeaderContainer style={style}>{children}</SubHeaderContainer>
}

export default SubHeader
